import DashboardLayout from "../layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "../pages/NotFoundPage.vue";

// Main pages
import ActivateUser from "../pages/ActivateUser.vue";
import Home from "../pages/Home.vue";
import News from "../pages/News.vue";
import NewsSingle from "../pages/NewsSingle.vue";
import Privacy from "../pages/Privacy.vue";
import Unsubscribe from "../pages/Unsubscribe.vue";

// Hero pages
import HeroLayout from "../layout/HeroLayout.vue";
import KynHeroProfile from "../pages/KynHeroProfile.vue";
import AmadorHeroProfile from "../pages/AmadorHeroProfile.vue";

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        children: [
            {
                path: "/",
                name: "Home",
                component: Home,
            },
            {
                path: "users/activate/",
                name: "ActivateUser",
                component: ActivateUser,
            },
            {
                path: "users/unsubscribe/",
                name: "Unsubscribe",
                component: Unsubscribe,
            },
            {
                path: "news-articles/",
                name: "News",
                component: News,
            },
            {
                path: "news-articles/:articleId/",
                name: "NewsSingle",
                component: NewsSingle,
            },
            {
                path: "/privacy/",
                name: "Privacy",
                component: Privacy,
            },
            {
                path: "heroes/",
                name: "Heroes",
                component: HeroLayout,
                children: [
                    {
                        path: "amador/",
                        name: "AmadorHeroProfile",
                        component: AmadorHeroProfile,
                        meta: {
                            hero: "Amador"
                        },
                    },
                    {
                        path: "kyn/",
                        name: "KynHeroProfile",
                        component: KynHeroProfile,
                        meta: {
                            hero: "Kyn"
                        },
                    },
                ]
            },
        ]
    },
    { path: "/:pathMatch(.*)*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
